import { z } from 'zod';
import { RECORD_TYPES, principalSchema } from './org.js';
/**
 * Kayıt defteri sözleşmeleri (WP 2.1, ADR-0003).
 * Her CRM varlığı `records` defterinde bir satırla temsil edilir; yan tablolar bu satıra FK ile bağlanır.
 * Durum: active (canlı) · deleted (soft-delete, geri alınabilir) · merged (başka kayda birleştirildi, geri alınamaz).
 */
export const recordTypeSchema = z.enum(RECORD_TYPES);
/**
 * Gerçek tablosu olan (`attach_record_core`) kayıt tipleri: M2 çekirdeği (şirket, kişi, ürün) + M3 satış tipleri (migration
 * 0038). Ad tarihsel; liste/görünüm/ACL/etiket/ek çerçevesinin kapsadığı tip kümesidir. Arama ve içe/dışa aktarma kendi
 * alt kümelerini tanımlar (`SEARCH_RECORD_TYPES`, `IMPORT_RECORD_TYPES`).
 */
export const M2_CORE_RECORD_TYPES = [
    'company',
    'contact',
    'product',
    'opportunity',
    'proposal',
    'order',
    'purchase_order',
    'lead',
    'contract',
    // M4 WP 4.1 (migration 0057)
    'activity',
    // M4 WP 4.3 (migration 0058)
    'ticket',
    // M5 WP 5.1 (migration 0063): form belgesi
    'form_document',
    // v3.1 S10 (migration 20261010_0140): ekip gelen kutusu konuşması (kanaldan gelir; genel oluşturma yolu yok)
    'conversation',
];
/** M2'nin kişi/şirket/ürün çekirdeği (içe/dışa aktarmanın bugünkü kapsamı; arama M3 satış tiplerini de kapsar). */
export const CRM_CORE_RECORD_TYPES = ['company', 'contact', 'product'];
/** M3 satış kayıt tipleri (müşteri adayı ve sözleşme dahil; migration 0038/0039/0041) */
export const SALES_RECORD_TYPES = [
    'opportunity',
    'proposal',
    'order',
    'purchase_order',
    'lead',
    'contract',
];
export const isSalesRecordType = (t) => SALES_RECORD_TYPES.includes(t);
/** M4 operasyon kayıt tipleri (aktivite: migration 0057; destek talebi: 0058). */
export const OPERATION_RECORD_TYPES = ['activity', 'ticket'];
export const isOperationRecordType = (t) => OPERATION_RECORD_TYPES.includes(t);
export const RECORD_STATUSES = ['active', 'deleted', 'merged'];
export const registryEntrySchema = z.object({
    id: z.guid(),
    recordType: recordTypeSchema,
    status: z.enum(RECORD_STATUSES),
    createdAt: z.string(),
    deletedAt: z.string().nullable(),
    mergedInto: z.guid().nullable(),
    mergedAt: z.string().nullable(),
});
export const mergeRecordsInputSchema = z
    .object({
    /** Kaynak kayıt (URL'deki id) bu kayda birleştirilir; kaynak soft-delete + merged işaretlenir. */
    targetId: z.guid(),
})
    .strict();
export const mergeRecordsResponseSchema = z.object({
    source: registryEntrySchema,
    target: registryEntrySchema,
});
/** Kayıt düzeyi ACL (WP 2.2, ADR-0001): sahip = owner_id; paylaşımlar read/write. */
export const RECORD_PERMS = ['read', 'write'];
export const recordAclEntrySchema = z.object({
    principal: principalSchema,
    perm: z.enum(RECORD_PERMS),
});
export const recordAclSchema = z.object({
    recordId: z.guid(),
    ownerId: z.guid().nullable(),
    ownerDeptId: z.guid().nullable(),
    readers: z.array(principalSchema),
    writers: z.array(principalSchema),
});
export const setRecordAclInputSchema = z
    .object({
    readers: z.array(principalSchema).max(100).default([]),
    writers: z.array(principalSchema).max(100).default([]),
})
    .strict();
// Liste sorgusu sözleşmeleri (filtre AST, sıralama, cursor, kayıtlı listeler) WP 2.4 ile `list-query.ts` dosyasına taşındı.
//# sourceMappingURL=records.js.map